import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  uid: undefined
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      return action.payload
    },
    setUserProps: (state, action) => {
      state[action.payload.key] = action.payload.value
    }
  }
})

// Action creators are generated for each case reducer function
export const { setUser, setUserProps } = userSlice.actions

export default userSlice.reducer
